// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSpeechBubbles = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      d="M14.863 15.974c-.669 2.472-3.422 4.333-6.71 4.333a8.36 8.36 0 0 1-1.553-.144 6.96 6.96 0 0 1-4.114 1.653.343.343 0 0 1-.223-.603 6.957 6.957 0 0 0 1.608-2.106c-1.622-1.038-2.582-2.626-2.582-4.296 0-2.242 1.714-4.172 4.114-5.026.028.232.071.46.13.686-2.094.771-3.551 2.427-3.551 4.344 0 1.512.932 2.952 2.5 3.86a.343.343 0 0 1 .146.419 6.65 6.65 0 0 1-1.179 1.9 6.196 6.196 0 0 0 2.825-1.448.342.342 0 0 1 .302-.082 7.882 7.882 0 0 0 1.587.161c2.897 0 5.297-1.556 5.983-3.614.254-.003.487-.013.717-.037z"
    />
    <path
      fill="currentColor"
      d="M21.476 17.338a.343.343 0 0 1-.22.604 8.781 8.781 0 0 1-5.21-2.116c-.388.073-.78.123-1.173.151-.24.034-.484.034-.727.034h-.113c-4.193 0-7.697-2.386-8.5-5.544a5.777 5.777 0 0 1-.175-1.371c0-3.813 3.895-6.915 8.675-6.915 4.78 0 8.67 3.102 8.67 6.915 0 2.122-1.234 4.138-3.318 5.445a8.967 8.967 0 0 0 2.091 2.797zm-7.457-2.006c.691.001 1.38-.069 2.057-.209h.072c.087 0 .17.034.233.093a8.081 8.081 0 0 0 3.93 1.927 8.658 8.658 0 0 1-1.677-2.62.343.343 0 0 1 .147-.421c2.027-1.173 3.237-3.045 3.237-5.006 0-3.435-3.58-6.23-7.985-6.23-4.406 0-7.989 2.801-7.989 6.23 0 3.435 3.583 6.233 7.975 6.236z"
    />
  </svg>
);
export default SvgSpeechBubbles;
